import { paginatedTransform } from 'src/services/skuit/utils'
import { Carrier, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Carriers {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Carrier>> => {
    const response = await this.api.get('/shipping/carriers', config)
    return paginatedTransform(Carrier)(response.data)
  }
}
